// dependencies
import { useRef } from "react";
import { FadeIn } from "react-slide-fade-in";

// styling
import "./Information.css";

import infoSections from "./informationData";

export default function Information() {
  const detailedInformation = useRef();

  return (
    <div className="information">
      <div className="banner">
        <div className="content-wrapper">
          <h1>Project Information</h1>
        </div>
      </div>
      <FadeIn
        from="bottom"
        positionOffset={100}
        triggeroffset={0}
        delayInMilliseconds={0}>
        <div className="project-description box box-large">
          <h2>Description</h2>
          <p>
            Our sponsor, Victor O. Leshyk, uses the 3D modeling software ZBrush
            to create impactful art for science communication. Being able to
            bring his art to life in the form of animated videos allows him to
            communicate even more effectively. Although the software allows for
            the creation of sophisticated models and rigs, users are unable to
            properly animate their creations. While models can be posed once and
            then exported, ZBrush in its current state cannot create multiple
            poses of the same object in one instance of a project, or save
            multiple poses to one file. As a result, in order to accomplish any
            form of animation, he must painstakingly pose, export and re-pose
            his models to create object files he can use as animation frames.
          </p>
          <p>
            Our team created a plugin that saves ZBrush users the time and
            effort that this process requires. By providing the ability to save
            multiple poses of an object as keyframes that can be placed on a
            timeline, we set up a much more streamlined process of creating
            simple animations with the powerful ZBrush modeling tool. This makes
            stop-motion animation accessible to our sponsor and to NAU’s Center
            for Ecosystem Science and Society without the need to learn complex
            animation processes and tools.
          </p>
          <p>
            The initial concept for this project was provided by our sponsor
            which can be found{" "}
            <a
              href="https://www.ceias.nau.edu/cs/CS_Capstone/Projects/F22/Leshyk_Victor_Zbrush_v03.pdf"
              target="_blank"
              rel="noreferrer">
              here
            </a>
            .
          </p>
        </div>
      </FadeIn>

      <FadeIn
        from="bottom"
        positionOffset={100}
        triggeroffset={0}
        delayInMilliseconds={0}>
        <div ref={detailedInformation} className="detailed-information">
          <div className="detail-navigation-wrapper">
            <div className="detail-navigation box">
              <h2>Detail Navigation</h2>
              {infoSections.map((section, index) => {
                return (
                  <div
                    key={index}
                    className="option"
                    onClick={() => {
                      document
                        .querySelector(`.${section.title.replace(" ", "-")}`)
                        .scrollIntoView({ behavior: "smooth", block: "start" });
                    }}>
                    {section.title}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="detail-wrapper">
            {/* <div className="detail-display"> */}
            {infoSections.map((section, key) => {
              return (
                <div
                  className={"box " + section.title.replace(" ", "-")}
                  key={key}>
                  <h1>{section.title}</h1>
                  <h2>{section.className}</h2>
                  {section.content}
                </div>
              );
            })}
            {/* </div> */}
          </div>
        </div>
      </FadeIn>
    </div>
  );
}
